import { render } from "./MatchList.vue?vue&type=template&id=3c581a00&scoped=true"
import script from "./MatchList.vue?vue&type=script&lang=js"
export * from "./MatchList.vue?vue&type=script&lang=js"

import "./MatchList.vue?vue&type=style&index=0&id=3c581a00&scoped=scoped&lang=css"

import exportComponent from "D:\\CODE\\clpgaAppDevnew\\clpga_html\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c581a00"]])

export default __exports__